
import {Component, Vue} from 'vue-property-decorator';
import AppSnackbar from '@/components/AppSnackbar.vue';
import DialogConfirm from '@/components/DialogConfirm.vue';
import AppHeader from '@/components/Layouts/AppHeader.vue';
import PasswordSnackbar from '@/components/PasswordSnackbar.vue';
import AppSplashScreen from '@/components/AppSplashScreen.vue';

@Component({
  components: {
    AppHeader,
    DialogConfirm,
    AppSnackbar,
    PasswordSnackbar,
    AppSplashScreen,
  },
})
export default class Main extends Vue {
  isLoading = true;

  mounted() {
    setTimeout(() => {
      this.isLoading = false;
    }, 1500);
  }
}
